/**
 * 全站公共 JS 逻辑，每个页面都会加载
 */

document.addEventListener('DOMContentLoaded', () => {
  // 下滑隐藏header，上滑显示，仅PC端生效
  let lastScrollY = window.scrollY
  const siteHeader = document.querySelector('.site-header')

  // 只在PC端执行
  if (window.innerWidth > 800 && siteHeader) {
    let ticking = false

    function onScroll() {
      const currentScrollY = window.scrollY
      // 向下滑且不是负的，隐藏header
      if (currentScrollY > lastScrollY && currentScrollY > 0) {
        siteHeader.style.transform = 'translateY(-100%)'
        siteHeader.style.transition = 'transform 0.3s'
      } else {
        // 向上滑，显示header
        siteHeader.style.transform = 'translateY(0)'
        siteHeader.style.transition = 'transform 0.3s'
      }
      lastScrollY = currentScrollY
      ticking = false
    }

    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(onScroll)
        ticking = true
      }
    }

    window.addEventListener('scroll', requestTick)
  }

  // 在此处编写各页面共用的逻辑，例如：
  // - 导航/菜单交互
  // - 语言切换
  // - 埋点或统计
  // - 公共组件初始化

  let expanded = false
  const hamburger = document.querySelector('.hamburger')
  const moMenuList = document.querySelector('.mo-menu-list')
  hamburger && hamburger.addEventListener('click', () => {
    expanded = !expanded
    if (expanded) {
      moMenuList.style.display = 'block'
    } else {
      moMenuList.style.display = 'none'
    }
  })
});
